module.exports = __webpack_public_path__ + "media/hallBgm.03d0a16a.mp3";